import React from 'react';
import { IExamApplicationDetails } from 'components/models';
import {
    Card,
    AutoGrowTextArea,
    LoaderBtn,
    SignedExpert,
    renderRow,
} from 'components';
import { Button, Form } from 'react-bootstrap';
import styles from './StatementTab.module.scss';
import cn from 'classnames';

const StatementTab = ({
    onCancel,
    onSubmit,
    contentClassName,
    sendingText,
    setSendingText,
    examApplication,
    withoutPadding,
    submitButtonText,
    cancelButtonText,
    processing,
}: IProps) => {
    const [showSendingTextError, setShowSendingTextError] = React.useState(false);
    const { applicant, applicantIdentityDoc, exam } = React.useMemo(() => examApplication, [examApplication]);

    const passport = applicantIdentityDoc && applicantIdentityDoc.passport;
    // const other = applicantIdentityDoc && applicantIdentityDoc.otherIdentity;
    const examName = exam ? `«${exam.qualificationTitle}»` : '';
    const identification = passport ? `паспорт № ${passport.serialNumber} выдан ${passport.issuedBy}` : '';
    const applicantFullName = `${applicant.lastName} ${applicant.firstName} ${applicant.middleName}`;

    const onOpenModal = () => {
        if (onSubmit) {
            if (sendingText !== '') {
                onSubmit();
                setShowSendingTextError(false);
            } else {
                setShowSendingTextError(true);
            }
        }
    };

    const onChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (setSendingText) {
            setSendingText(e.target.value);
            setShowSendingTextError(false);
        }
    };

    return (
        <Card
          title="Заявление"
          category="для проведения независимой оценки квалификации"
          contentClassName={contentClassName}
          withoutPadding={withoutPadding}
          withoutPaddingTitle={withoutPadding}
          headerClassName={withoutPadding ? 'pt-0' : undefined}
          withoutBorder
          withoutBottomMargin
        >
            <span className={styles.text}>
                Я, {applicantFullName}, дата рождения {applicant.birthDate.format('DD.MM.YYYY')}, {identification}. Прошу допустить меня к сдаче профессионального экзамена по квалификации {examName} .<br />
                <br />
                Контактные данные:<br />
                <br />
                адрес регистрации по месту жительства:<br />
                <span style={{ whiteSpace: 'pre-wrap' }}>{passport ? passport.registrationAddress : ''}</span> <br />
                <br />
                контактный телефон:<br />
                +7 {applicant.phone}<br />
                <br />
                электронная почта:<br />
                {applicant.email}<br />
                <br />
                С Правилами проведения центром оценки квалификаций независимой оценки
                квалификации в форме профессионального экзамена, утвержденными постановлением
                Правительства Российской Федерации от 16.11.2016 г. № 1204 (Официальный интернет-
                портал правовой информации http://www.pravo.gov.ru, 22.11.2016), ознакомлен(а).
                <br />
                О готовности оформления свидетельства о квалификации или заключения о
                прохождении профессионального экзамена прошу уведомить по контактному телефону
                или адресу электронной почты, указанным в настоящем заявлении.
                <br />
                Оригинал Свидетельства профессионального экзамена прошу направить заказным почтовым отправлением с уведомлением по следующему адресу:<br />
            </span>

            {sendingText !== undefined && setSendingText ? (
                <>
                    <AutoGrowTextArea
                      value={sendingText}
                      className={styles.textArea}
                      onChange={onChangeTextArea}
                      autoFocus
                    />
                    {showSendingTextError ? (
                        <Form.Control.Feedback className="d-block" type="invalid">
                            Обязательное поле для заполнения
                        </Form.Control.Feedback>
                    ) : null}
                </>
            ) : (
                    <span className={styles.text_address}>{examApplication.certificateDeliveryAddress}</span>
                )}

            <span className={cn(styles.text, styles.text_end)}>
                Приложения:<br />
                1. Копия паспорта или иного документа, удостоверяющего личность.<br />
                2. Копии документов, указанных в реестре сведений о проведении независимой<br />
                оценки квалификации, необходимых для прохождения профессионального<br />
                экзамена по оцениваемой квалификации.<br />
                <br />
                Я согласен(на) на обработку в соответствии с Федеральным законом от 27 июля
                2006 г. № 152-ФЗ «О персональных данных» (Собрание законодательства Российской
                Федерации, 2006, № 31, ст. 3451) моих персональных данных, указанных в настоящем
                заявлении и прилагаемых к нему документах (фамилия, имя, отчество (при наличии), дата
                и место рождения, реквизиты документа, удостоверяющего личность, - наименование документа, серия, номер, кем выдан и когда, месте проживания (регистрации), место
                работы, образование и квалификация), а также результатов прохождения
                профессионального экзамена, присвоения квалификации и выдачи свидетельства о
                квалификации, внесения и хранения соответствующей информации в реестре сведений о
                проведении независимой оценки квалификации в соответствии с Федеральным законом от
                03.07.2016 г. № 238-ФЗ «О независимой оценке квалификации».
                Я уведомлен(а) и понимаю, что под обработкой персональных данных
                подразумевается совершение следующих действий (операций): сбор, обработка, запись,
                систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение,
                использование, подтверждение, передача (распространение, предоставление, доступ),
                обезличивание, блокирование, удаление, уничтожение персональных данных по
                истечении срока действия настоящего согласия в соответствии с Федеральным законом
                от 27 июля 2006 г. № 152-ФЗ «О персональных данных».
            </span>
            {examApplication.signCode ? (renderRow('Подпись',
                <SignedExpert
                  commissionTitle="Соискатель"
                  expert={{
                        fullName: applicantFullName,
                        signed: true,
                        signedCode: examApplication.signCode,
                    }}
                />,
                (onSubmit || onCancel) && 'mb-5')) : null}

            {onSubmit ? (
                <LoaderBtn
                  variant="primary"
                  className={cn('pl-4 pr-4')}
                  onClick={onOpenModal}
                  loading={processing}
                  disabled={processing}
                >
                    {submitButtonText || 'Подписать и отправить заявку'}
                </LoaderBtn>
            ) : null}

            {onCancel ? (
                <Button
                  className={cn('ml-4')}
                  variant="outline-secondary"
                  onClick={onCancel}
                  disabled={processing}
                >
                    {cancelButtonText || 'Вернуться к редактированию заявки'}
                </Button>
            ) : null}
        </Card>
    );
};

export default StatementTab;

interface IProps {
    examApplication: IExamApplicationDetails;
    contentClassName?: string;
    children?: React.ReactNode;
    sendingText?: string;
    withoutPadding?: boolean;
    submitButtonText?: string;
    cancelButtonText?: string;
    processing?: boolean;
    setSendingText?: (text: string) => void;
    onCancel?: () => void;
    onSubmit?: () => void;
}
